import * as React from 'react';
import cx from 'classnames';
import { components } from 'react-select';

import Checkbox from 'components/Checkbox';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import Select, { Props as SelectProps } from 'components/SelectDeprecated';

import './styles/MultiSelect.scss';

export interface Props extends SelectProps {
  dataTestSelector?: string;
  maxItems?: number;
  optionListHeader?: React.ReactChild;
}

class MultiSelect extends React.Component<Props> {
  render() {
    const { dataTestSelector, maxItems, ...opts } = this.props;

    const Option = (props: any) => {
      const optionClassName = 'MultiSelect-optionswrapper-option';
      const optionClassDivName = 'MultiSelect-optionswrapper';
      return (
        <div
          className={cx(optionClassDivName, props.isFocused && `${optionClassDivName}--isfocused`)}
        >
          <components.Option {...props} className={optionClassName}>
            <MediaObject center gutter="xsmall">
              <Checkbox checked={props.isSelected} onChange={() => null} />
              <Text
                size="xsmall"
                color="graphite"
                data-test-selector={`${dataTestSelector || ''}-${props.label}`}
              >
                {props.label}
              </Text>
            </MediaObject>
          </components.Option>
        </div>
      );
    };

    const MultiValue = (props: any): any => {
      const { data, index } = props;

      const maxItemsCount = maxItems || 3;

      if (index > maxItemsCount) {
        return null;
      }
      let newLabel = data.label;
      if (index > 0) {
        newLabel = index === maxItemsCount ? '...' : ', ' + newLabel;
      }

      return (
        <div className="input-select-container">
          <div className="input-select-label-container">
            <span className="input-select-label">{newLabel}</span>
          </div>
        </div>
      );
    };

    const CustomStyle = {
      option: (provided: any) => ({
        ...provided,
        backgroundColor: 'transparent',
      }),
    };

    // extra components definition
    // validates if the select component will add extra components from an external implementation
    let extraComponents: any = {};
    if (this.props.optionListHeader) {
      extraComponents.MenuList = (props: any) => (
        <components.MenuList {...props}>
          {this.props.optionListHeader}
          {props.children}
        </components.MenuList>
      );
    }

    return (
      <Select
        isMulti
        components={{ MultiValue, Option, ...extraComponents }}
        styles={CustomStyle}
        {...opts}
      />
    );
  }
}

export default MultiSelect;
